import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { baseApi } from '@/api/baseApi';
import authReducer from '@/store/slices/authSlice';

import '@/api/articlesApi';
import '@/api/categoriesApi';
import '@/api/citiesApi';
import '@/api/commentsApi';
import '@/api/cuisineTypesApi';
import '@/api/ingredientGroupsApi';
import '@/api/ingredientsApi';
import '@/api/moderationApi';
import '@/api/paymentsApi';
import '@/api/recipesApi';
import '@/api/subscriptionsApi';
import '@/api/tariffsApi';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        [baseApi.reducerPath]: baseApi.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(baseApi.middleware)
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
